export default "__VITE_ASSET__DQZjyNwn__"